import { GlobalPositionStrategy, OverlayRef } from "@angular/cdk/overlay";
import { Observable, Subject } from "rxjs";
import { filter, take } from "rxjs/operators";

import { DialogPosition } from "./dialog-config";
import { DialogContainerComponent } from "./dialog-container.component";

let uniqueId = 0;

export class DialogRef<T, R = any> {
	open: boolean;
	componentInstance: T;
	private readonly afterClosed$ = new Subject<R | undefined>();

	constructor(
		private overlayRef: OverlayRef,
		readonly id = `tr-dialog-${uniqueId++}`,
		private container: DialogContainerComponent,
	) {
		container.animationStateChanged
			.pipe(
				filter(event => (event ? event === "exit" : false)),
				take(1),
			)
			.subscribe(() => {
				this.overlayRef.detachBackdrop();
				this.overlayRef.dispose();
				this.open = false;
			});
		this.open = true;
	}

	close(result?: R): void {
		this.afterClosed$.next(result);
		this.container.startExitAnimation();
	}

	afterClosed(): Observable<R | undefined> {
		return this.afterClosed$.asObservable();
	}

	updatePosition(position?: DialogPosition): this {
		const strategy = this.getPositionStrategy();

		if (position && (position.left || position.right)) {
			position.left ? strategy.left(position.left) : strategy.right(position.right);
		} else {
			strategy.centerHorizontally();
		}

		if (position && (position.top || position.bottom)) {
			position.top ? strategy.top(position.top) : strategy.bottom(position.bottom);
		} else {
			strategy.centerVertically();
		}

		this.overlayRef.updatePosition();

		return this;
	}

	updateSize(width = "", height = ""): this {
		const config = this.overlayRef.getConfig();
		config.width = width;
		config.height = height;
		this.overlayRef.updatePosition();
		return this;
	}

	private getPositionStrategy(): GlobalPositionStrategy {
		return this.overlayRef.getConfig().positionStrategy as GlobalPositionStrategy;
	}
}
